import { Tags } from "lucide-react";

import {
  AgentApprovalBatchCard,
  type ApprovalRow,
} from "./AgentApprovalBatchCard";

type SkillApproval = {
  contact_id: number;
  contact_label: string;
  approval_id: string;
  domain: string | null;
  proposed_secteur: string | null;
  proposed_company: string | null;
};

export const SignupQualifCard = () => (
  <AgentApprovalBatchCard<SkillApproval>
    title="Qualifier les nouveaux inscrits"
    description="Déduit secteur cible + entreprise depuis le domaine email des inscrits récents. Tu valides chaque proposition (1 clic = pose secteur + crée company si besoin)."
    icon={Tags}
    iconClass="text-fabrik-accent-text"
    ctaLabel="Qualifier les inscrits récents"
    emptyLabel="Aucun inscrit à qualifier."
    skillId="qualify_signup_from_email"
    skillInput={{ days_back: 7, limit: 15 }}
    approveSuccessLabel="Qualifié"
    toRow={(
      a,
    ): Pick<ApprovalRow, "approval_id" | "contact_label" | "subtitle"> => ({
      approval_id: a.approval_id,
      contact_label: a.contact_label,
      subtitle: `${a.domain ?? "—"} → ${a.proposed_secteur ?? "?"}${a.proposed_company ? ` · ${a.proposed_company}` : ""}`,
    })}
    extractBody={(payload) => {
      const lines: string[] = [];
      if (payload.secteur_label)
        lines.push(`Secteur : ${payload.secteur_label}`);
      if (payload.company_name)
        lines.push(`Entreprise : ${payload.company_name}`);
      if (payload.source) lines.push(`Source : ${payload.source}`);
      if (payload.notes) lines.push("", String(payload.notes));
      return { body: lines.join("\n") || "(aucune proposition)" };
    }}
    applyEdits={(payload, _subtitle, body) => {
      // L'édition libre n'est pas adaptée ici (champs structurés).
      // On stocke le texte modifié en notes, le reste reste tel quel.
      return { ...payload, notes: body };
    }}
  />
);
